import * as AddBooking from './components/AddBooking.css';
export default {
    AddBooking
};
